import { SvgInfo, SvgSuccess } from "components/svg";
import { useController } from "react-hook-form";
import { generateKey } from "utils/helpers";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

interface CustomSelectorProps {
    name: string;
    control: any;
    items: any[];
    selected: string | number | undefined;
    onChange(code:any, label: string): void;
    itemLength?: string;
    svgSize?: string;
    customFilter?: any;
}

const CustomSelector: React.FC<CustomSelectorProps> = ({name, items, selected, onChange, itemLength, svgSize, customFilter, control}) => {
    const { isThermor } = useSalesNetwork();
    const { t } = useTranslation();

    const {
        fieldState: { invalid }
    } = control && name && useController({
        name,
        control
    });

    return (
        <>
            {
                items?.map((item: any) => {
                    const showItem : boolean = customFilter ? customFilter(item?.value) : true;

                     return showItem && (
                        <group
                            key={generateKey()} data-wrap="no"
                            data-cursor="pointer"
                            data-interactive=""
                            data-length={itemLength? itemLength : "230"}
                            data-height="100"
                            data-space="10"
                            data-gap="10"
                            data-align="center"
                            data-border='inheret'
                            data-justify="center"
                            {...(isThermor ? {"data-border-color": "main-color-custom-border"} : {"data-color":"main"})}
                            {...(selected === item.code ? { "data-background": "main-color-custom-lighter", "data-name": "custom_option_select" } : { "data-border-color": "main-color-custom-border" })}

                            onClick={() => onChange(item.code as any, item.label)}
                        >
                            <icon data-svg-size={svgSize ?? "32"} data-svg-color="main">{item.icon}</icon>
                            <text 
                                data-clamp="3" 
                                data-wrap="wrap" 
                                //data-length="auto"
                                >{t(item.label)}</text>
                            {selected === item.code && <icon data-svg-size="16" 
                                data-svg-color={isThermor ? "main" : "success-color"}
                                //data-position="right"
                                >
                                <SvgSuccess />
                            </icon>}
                        </group>
                        
                    )
                })
            }
            {
                invalid && <errormessage data-gap="10" data-color="error-color">
                    <icon data-svg-size="14" data-svg-color="error-color">
                        <SvgInfo /></icon>{ t("FIELD_VALIDATION_REQUIRED_VALUE")}
                </errormessage>
            }
        </>
    )
}

export default CustomSelector;